import { IAppState } from '../../redux';
import { EBetPositionClientError } from '../../redux/reducers';
import { selectGeoChildLocation } from '../offer';
import { selectServiceIds } from '../publishTerms';

export function selectBetPositionClientError(state: IAppState): EBetPositionClientError | null {
  const {
    offer: {
      bargainTerms: { price },
    },
  } = state;

  const serviceIds = selectServiceIds(state);
  const childLocation = selectGeoChildLocation(state);

  const isPriceEmpty = !price;
  const isGeoEmpty = !childLocation;

  if (isPriceEmpty && isGeoEmpty) {
    return EBetPositionClientError.priceAndGeoEmpty;
  }

  if (isGeoEmpty) {
    return EBetPositionClientError.geoEmpty;
  }

  if (isPriceEmpty) {
    return EBetPositionClientError.priceEmpty;
  }

  if (serviceIds.length === 0) {
    return EBetPositionClientError.servicesEmpty;
  }

  return null;
}
